import { PartnerListPage } from '@/features/partners/components/partner-list-page';

export function PartnerCustomersRoute(): JSX.Element {
  return (
    <PartnerListPage
      type="customer"
      titleKey="partners.customers.title"
      subtitleKey="partners.customers.subtitle"
      createLabelKey="partners.actions.createCustomer"
      formPreset="customer"
    />
  );
}
